/**
 * Store Location Transformer
 * Handles transformation of store locations (branches/sucursales) from API to application domain model
 * Single Responsibility: Store location data transformation only
 */

/**
 * Transforms store locations (branches/sucursales) list response
 * @param {Array} rawLocations - Raw locations array from API
 * @returns {Array} Transformed locations array
 */
export function transformStoreLocations(rawLocations) {
  if (!Array.isArray(rawLocations)) {
    return [];
  }

  return rawLocations.map((location) => ({
    id: location.id,
    name: location.name || "",
    displayName: location.display_name || location.displayName || "",
    alias: location.alias || "",
    ...location
  }));
}
